let mock = {
  movimientos: [
    {
      subAgencia: null,
      cliente: "",
      fecha: "",
      imputacion: "",
      codigo: null,
      descripcion: "Total SubAg. 0",
      cantCupones: 4,
      total: 355.0,
    },
    {
      subAgencia: 0,
      cliente: "xxx-0e67",
      fecha: "2023-05-18",
      imputacion: "Tombola",
      codigo: 1,
      descripcion: "Recaudación",
      cantCupones: 2,
      total: 155.0,
    },
    {
      subAgencia: 0,
      cliente: "xxx-2aff",
      fecha: "2023-05-19",
      imputacion: "Tombola",
      codigo: 1,
      descripcion: "Recaudación",
      cantCupones: 1,
      total: 100.0,
    },
    {
      subAgencia: 0,
      cliente: "xxx-0e67",
      fecha: "2023-05-19",
      imputacion: "Tombola",
      codigo: 1,
      descripcion: "Recaudación",
      cantCupones: 1,
      total: 100.0,
    },
    {
      subAgencia: null,
      cliente: "",
      fecha: "",
      imputacion: "",
      codigo: null,
      descripcion: "Total SubAg. 1",
      cantCupones: 4,
      total: 355.0,
    },
    {
      subAgencia: 1,
      cliente: "xxx-0e67",
      fecha: "2023-05-18",
      imputacion: "Tombola",
      codigo: 1,
      descripcion: "Recaudación",
      cantCupones: 2,
      total: 155.0,
    },
    {
      subAgencia: 1,
      cliente: "xxx-2aff",
      fecha: "2023-05-19",
      imputacion: "Tombola",
      codigo: 1,
      descripcion: "Recaudación",
      cantCupones: 1,
      total: 100.0,
    },
    {
      subAgencia: 1,
      cliente: "xxx-0e67",
      fecha: "2023-05-19",
      imputacion: "Tombola",
      codigo: 1,
      descripcion: "Recaudación",
      cantCupones: 1,
      total: 100.0,
    },
    {
      subAgencia: null,
      cliente: "",
      fecha: "",
      imputacion: "",
      codigo: null,
      descripcion: "Total SubAg. 2",
      cantCupones: 4,
      total: 355.0,
    },
    {
      subAgencia: 2,
      cliente: "xxx-0e67",
      fecha: "2023-05-18",
      imputacion: "Tombola",
      codigo: 1,
      descripcion: "Recaudación",
      cantCupones: 2,
      total: 155.0,
    },
    {
      subAgencia: 2,
      cliente: "xxx-2aff",
      fecha: "2023-05-19",
      imputacion: "Tombola",
      codigo: 1,
      descripcion: "Recaudación",
      cantCupones: 1,
      total: 100.0,
    },
    {
      subAgencia: 2,
      cliente: "xxx-0e67",
      fecha: "2023-05-19",
      imputacion: "Tombola",
      codigo: 1,
      descripcion: "Recaudación",
      cantCupones: 1,
      total: 100.0,
    },
  ],
};

export default mock;
